/**
 * Gets page type from path using following format: /{LOCALE}/{IDENTIFIER}/{SLUG}
 *
 * Identifiers:
 *  product -> PDP
 *  categories -> PLP
 *
 * Root `/` is the site selector (no locale). Locale-only paths -> Homepage.
 * Anything else -> the first slug after the locale (e.g. /en/snow -> "snow").
 *
 * @param path - The path to get the page type from
 * @returns The page type
 */
export const getPageNameFromPath = (path: string) => {
    if (path === "/" || path === "") return "Site selector"

    const parts = path.split("/")
    const pageType = parts[2] ?? ""

    switch (pageType) {
        case "":
            return "Homepage"
        case "product":
            return "PDP"
        case "categories":
            return "PLP"
        default:
            return pageType
    }
}
